var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 1V6.25M34.25 1V6.25M1 37.75V11.5C1 10.1076 1.55312 8.77226 2.53769 7.78769C3.52226 6.80312 4.85761 6.25 6.25 6.25H37.75C39.1424 6.25 40.4777 6.80312 41.4623 7.78769C42.4469 8.77226 43 10.1076 43 11.5V37.75M43 37.75V20.25C43 18.8576 42.4469 17.5223 41.4623 16.5377C40.4777 15.5531 39.1424 15 37.75 15H6.25C4.85761 15 3.52226 15.5531 2.53769 16.5377C1.55312 17.5223 1 18.8576 1 20.25V37.75C1 39.1424 1.55312 40.4777 2.53769 41.4623C3.52226 42.4469 4.85761 43 6.25 43H37.75C39.1424 43 40.4777 42.4469 41.4623 41.4623C42.4469 40.4777 43 39.1424 43 37.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.f5e4eab31e89c41dd96044213672d99d.svg";
export { ForwardRef as ReactComponent };